import { render, staticRenderFns } from "./levelUp.vue?vue&type=template&id=2cca4930&scoped=true&"
import script from "./levelUp.vue?vue&type=script&lang=js&"
export * from "./levelUp.vue?vue&type=script&lang=js&"
import style0 from "./levelUp.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./levelUp.vue?vue&type=style&index=1&id=2cca4930&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cca4930",
  null
  
)

export default component.exports